@if (enabled) {
  <button (click)="action.emit()" [title]="'frame.overlay_button' | transloco" mat-icon-button>
    <mat-icon class="fill">crop_free</mat-icon>
  </button>
}
